import { useWorkspaceId } from 'api/providers/workspaceProvider';
import { useCallback, useEffect, useState } from 'react';

import { getPinnedEntityIds } from '../../utils/dashboard';
import type { PinnedEntitiesProps } from './index.types';

export function usePinnedEntitiesController(props: PinnedEntitiesProps) {
  const { compact } = props;

  const workspaceId = useWorkspaceId();

  const [pinnedEntityIds, setPinnedEntityIds] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadPinnedEntities = () => {
      const ids = getPinnedEntityIds(workspaceId);
      setPinnedEntityIds(ids);
      setIsLoading(false);
    };

    loadPinnedEntities();

    // Listen for dashboard changes
    const handleDashboardChange = () => {
      loadPinnedEntities();
    };

    // Listen for storage changes to update when entities are pinned/unpinned from other tabs
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'finsight_dashboard_config') {
        loadPinnedEntities();
      }
    };

    window.addEventListener('dashboardChanged', handleDashboardChange);
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('dashboardChanged', handleDashboardChange);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [workspaceId]);

  const refreshPinnedEntities = useCallback(() => {
    const ids = getPinnedEntityIds(workspaceId);
    setPinnedEntityIds(ids);
  }, [workspaceId]);

  return {
    pinnedEntityIds,
    isLoading,
    compact,
    refreshPinnedEntities,
  };
}
